import styled from 'styled-components';

const SCROLL_HIGHLIGHT_WIDTH_REM = 0.25;
const ScrollHighlightRight = styled.div`
  display: none;
  background: linear-gradient(to right, rgba(255, 0, 0, 0), rgba(0, 0, 0, 0.05));
  height: 100%;
  width: ${SCROLL_HIGHLIGHT_WIDTH_REM}rem;
  position: absolute;
  top: 0;
  left: -${SCROLL_HIGHLIGHT_WIDTH_REM}rem;
  pointer-events: none;
`;
const ScrollHighlightLeft = styled.div`
  display: none;
  background: linear-gradient(to left, rgba(255, 0, 0, 0), rgba(0, 0, 0, 0.05));
  height: 100%;
  width: ${SCROLL_HIGHLIGHT_WIDTH_REM}rem;
  position: absolute;
  top: 0;
  right: -${SCROLL_HIGHLIGHT_WIDTH_REM}rem;
  pointer-events: none;
`;

export { SCROLL_HIGHLIGHT_WIDTH_REM, ScrollHighlightLeft, ScrollHighlightRight };
